var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 15.9242C4.5 15.3642 4.94697 14.9102 5.49834 14.9102C6.0497 14.9102 6.49668 15.3642 6.49668 15.9242V17.972L18.5033 17.972V15.9242C18.5033 15.3642 18.9503 14.9102 19.5017 14.9102C20.053 14.9102 20.5 15.3642 20.5 15.9242V17.972C20.5 19.092 19.6061 20 18.5033 20H6.49668C5.39394 20 4.5 19.092 4.5 17.972V15.9242ZM15.7502 9.36704L13.4611 7.04202V15.0014C13.4611 15.5614 13.0141 16.0154 12.4628 16.0154C11.9114 16.0154 11.4644 15.5614 11.4644 15.0014V7.04203L9.17533 9.36704C8.78546 9.76303 8.15335 9.76303 7.76347 9.36704C7.3736 8.97104 7.3736 8.32901 7.76347 7.93301L11.0509 4.59399C11.8306 3.802 13.0949 3.802 13.8746 4.59399L17.162 7.93301C17.5519 8.32901 17.5519 8.97104 17.162 9.36704C16.7722 9.76303 16.14 9.76303 15.7502 9.36704Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.96532b2966d422c381d0e54a7ec7da54.svg";
export { ForwardRef as ReactComponent };